import { useEffect, useRef, useState } from "react";
import "./style.scss";

export const ScrollSection = ({ children, showScroll = false }) => {
	const containerRef = useRef(null);
	const [isHolding, setIsHolding] = useState(false);
	const [startScrollLeft, setStartScrollLeft] = useState(0);
	const scrollLeftRef = useRef(0);

	const [startMask, setStartMask] = useState(false);
	const [endMask, setEndMask] = useState(true);

	const [hasScroll, setHasScroll] = useState(false);

	const [childElementWidth, setChildElementWidth] = useState(0);

	useEffect(() => {
		const container = containerRef.current;

		const onMouseDown = (event) => {
			if (!container) return;
			if (event.button != 0) return;
			event.preventDefault();
			setIsHolding(true);
			setStartScrollLeft(event.clientX);
			scrollLeftRef.current = container.scrollLeft;
		};

		const onMouseUp = () => {
			setIsHolding(false);
		};

		const onMouseMove = (event) => {
			if (isHolding && container) {
				const delta = event.clientX - startScrollLeft;
				container.scrollLeft = scrollLeftRef.current - delta;
			}
		};

		const onScroll = () => {
			if (!container) return;
			setStartMask(container.scrollLeft > 0);
			setEndMask(container.scrollLeft < container.scrollWidth - container.clientWidth);
		};

		if (container) {
			container.addEventListener("mousedown", onMouseDown);
			container.addEventListener("mouseup", onMouseUp);
			container.addEventListener("mousemove", onMouseMove);
			container.addEventListener("scroll", onScroll);
		}

		return () => {
			if (container) {
				container.removeEventListener("mousedown", onMouseDown);
				container.removeEventListener("mouseup", onMouseUp);
				container.removeEventListener("mousemove", onMouseMove);
				container.removeEventListener("scroll", onScroll);
			}
		};
	});

	useEffect(() => {
		if (containerRef.current != undefined) {
			setHasScroll(containerRef.current?.scrollWidth - containerRef.current?.clientWidth > 0);
			setStartMask(containerRef.current.scrollLeft > 0);
			setEndMask(containerRef.current.scrollLeft < containerRef.current.scrollWidth - containerRef.current.clientWidth);

			setChildElementWidth(containerRef.current.scrollWidth / children.length);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [containerRef.current, children]);

	const clickScroll = (amount) => {
		if (containerRef.current) {
			containerRef.current.style.scrollBehavior = "smooth";
			containerRef.current.scrollLeft += amount;
			scrollLeftRef.current = containerRef.current.scrollLeft;
			containerRef.current.style.scrollBehavior = "auto";
		}
	};

	return (
		<div className="scroll-holder">
			{/* {startMask && (
				<div
					className="arrow startArrow"
					onClick={() => {
						clickScroll(-childElementWidth);
					}}
				>
					<Icon icon={arrow} size={15} color="currentColor" style={{ height: 20 }} />
				</div>
			)} */}
			<div
				ref={containerRef}
				className={`scroll-container 
                        ${startMask ? "start-mask" : ""}
                        ${endMask ? "end-mask" : ""}
                        ${hasScroll ? "grab" : ""}
                        ${isHolding && hasScroll ? "grabbing" : ""}
                    `}
				style={{
					scrollbarWidth: showScroll ? "thin" : "none",
				}}
			>
				{children}
			</div>
			{/* {endMask && (
				<div
					className="arrow endArrow"
					onClick={() => {
						clickScroll(childElementWidth);
					}}
				>
					<Icon icon={arrow} size={15} color="currentColor" style={{ height: 20 }} rotation={180} />
				</div>
			)} */}
		</div>
	);
};
